
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 135576","transform":"translate(-.425)"}},[_c('rect',{attrs:{"data-name":"Rectangle 111408","width":"46","height":"46","rx":"12","transform":"translate(.425)","fill":"#245389","opacity":".1"}}),_c('g',{attrs:{"data-name":"Group 135571"}},[_c('g',{attrs:{"data-name":"vuesax/twotone/3dcube"}},[_c('g',{attrs:{"data-name":"3dcube","fill":"none","stroke":"#245389","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M24.074 11.636l7.593 4.095a1.346 1.346 0 010 2.322l-7.595 4.095a2.259 2.259 0 01-2.147 0l-7.593-4.095a1.346 1.346 0 010-2.322l7.595-4.095a2.259 2.259 0 012.147 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.211 20.818l7.059 3.535a2.612 2.612 0 011.435 2.325v6.67a1.294 1.294 0 01-1.878 1.155l-7.059-3.535a2.612 2.612 0 01-1.435-2.322v-6.673a1.294 1.294 0 011.878-1.155zM32.788 20.818l-7.058 3.535a2.612 2.612 0 00-1.435 2.325v6.67a1.294 1.294 0 001.878 1.155l7.059-3.535a2.612 2.612 0 001.435-2.322v-6.673a1.294 1.294 0 00-1.879-1.155z","opacity":".4"}})])])])])])
          )
        }
      }
    